<main class="greetings-dashboard-container bg-black text-white min-h-screen overflow-x-hidden" role="main">
  <div class="dashboard-wrapper max-w-7xl mx-auto px-4 py-8">
    <!-- Page Header -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">Greetings & Notifications Manager</h1>
        <p class="page-subtitle">Manage email templates and send notifications to users</p>
      </div>
    </div>

    <!-- Tab Navigation -->
    <div class="tab-navigation">
      <button 
        class="tab-button"
        [class.active]="activeTab === 'email'"
        (click)="switchTab('email')">
        <i class='bx bx-envelope'></i>
        <span>Email Templates</span>
      </button>
      <button 
        class="tab-button"
        [class.active]="activeTab === 'notification'"
        (click)="switchTab('notification')">
        <i class='bx bx-bell'></i>
        <span>Send Notification</span>
      </button>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
      <!-- Email Panel -->
      <div *ngIf="activeTab === 'email'" class="tab-pane active">
        <app-email-panel></app-email-panel>
      </div>

      <!-- Notification Panel -->
      <div *ngIf="activeTab === 'notification'" class="tab-pane active">
        <app-notification-panel></app-notification-panel>
      </div>
    </div>
  </div>
</main>
